import React from 'react'
import ThemeDashboard from "./theme-dashboard";

const Themes = ({}) => {
    return (
        <>
            <ThemeDashboard/>
        </>
    )
}

export default Themes
